import { Box, Container, Grid, Paper, Stack } from '@mui/material';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { fetchAPI } from '../../../api/request';
import Alert from '../../../components/common/Alert.component';
import Back from '../../../components/common/Back.component';
import Loading from '../../../components/common/Loading.component';
import AddView from '../../../views/Add.view';
import { API as departments } from '../../../module/departments/api';
import _ from 'lodash';
import NewYachtForm from '../../../components/yacht/NewYachtForm.component';
import { API as yachts } from '../../../module/yachts/api';
import AgentNAForm from '../../../components/agentNA/AgentNAForm.component';
import dayjs from 'dayjs';

const TechnicalAddPage = ({ module: { code, query, create } }) => {
  const { jwt, user } = useSelector((state) => state.login);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [idDepartment, setIdDepartment] = useState(null);
  const [valueTab, setValueTab] = useState(0);
  const [conf, setConf] = useState(create.conf.id_yacht);

  const userInCharge = useMemo(
    () =>
      user && user?.id_users_nautica?.id
        ? {
            id: user?.id_users_nautica?.id,
            name: `${user?.name} ${user?.surname}`,
          }
        : null,
    [user]
  );

  const handleChangeTab = (event, newValue) => {
    setValueTab(newValue);
  };

  const onError = useCallback(() => {
    setSuccess(false);
    setLoading(false);
    setError(true);
    // eslint-disable-next-line
  }, []);

  const onSubmit = useCallback(
    (values) => {
      const dataNewYacht = {
        yacht_name: values?.yacht_name,
        registry_type: values?.registry_type?.id,
        port_of_registry: values?.port_of_registry,
        loa: values?.loa,
        beam: values?.beam,
        draft: values?.draft,
        gross_tonn: values?.gross_tonn,
        yacht_type: values?.yacht_type?.id,
        date_submit_signature: dayjs().format('YYYY-MM-DD'),
        registration_status: 'PENDING',
      };
      const dataCommon = {
        ...values,
        id_department: idDepartment,
        id_user_last_updated: user?.id_users_nautica?.id || null,
      };
      const data =
        valueTab !== 0
          ? {
              ...dataCommon,
              ...dataNewYacht,
            }
          : dataCommon;
      setError(false);
      setSuccess(false);
      setLoading(true);
      fetchAPI(query.create.settings, {}, '', data, jwt)
        .then(() => {
          setSuccess(true);
          setError(false);
          setLoading(false);
        })
        .catch(onError);
    },
    [jwt, onError, setSuccess, idDepartment, user, query, setError, valueTab]
  );

  useEffect(() => {
    fetchAPI(departments.select, { code: code }, '', null, jwt)
      .then((response) => {
        setIdDepartment(_.head(response)?.id);
      })
      .catch(onError);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (valueTab !== 0) {
      setConf(create.conf.newYacht);
    } else {
      setConf(create.conf.id_yacht);
    }
  }, [valueTab, create]);

  return (
    <Container disableGutters={true} maxWidth={false} sx={{ height: '100%' }}>
      <Stack
        spacing={2}
        sx={{ padding: 2 }}
        justifyContent='center'
        alignItems='center'
      >
        <Back title={'technical'} />
        <Container>
          {loading && <Loading />}
          {success && <Alert severity='success'>{'Success: Add'}</Alert>}
          {error && <Alert severity='error'>{'An error has occurred'}</Alert>}

          <Paper variant='outlined'>
            <Box sx={{ padding: 2 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <AddView
                    conf={{
                      ...conf,
                      defaultValues: {
                        ...conf?.defaultValues,
                        id_user_in_charge: userInCharge,
                      },
                    }}
                    disabled={loading || success}
                    onAddSubmit={onSubmit}
                    actions={
                      <NewYachtForm
                        valueTab={valueTab}
                        handleChange={handleChangeTab}
                        api={yachts.selectNoDRAFT}
                      >
                        {valueTab === 0 && <AgentNAForm />}
                      </NewYachtForm>
                    }
                  />
                </Grid>
              </Grid>
            </Box>
          </Paper>
        </Container>
      </Stack>
    </Container>
  );
};

export default TechnicalAddPage;
